import { combineReducers } from 'redux';

import reports from './reports/reducer';
import readingsHistory from './readingsHistory/reducer';
import settings from './settings/reducer';

export default combineReducers({
  reports,
  readingsHistory,
  settings,
});
